import React, { useState } from "react";
import Banking from "./Banking";
import Cassettes from "./Cassettes";
import Fees from "./Fees";
import Last24HourTrans from "./Last24HourTrans";
import MgmtActivity from "./MgmtActivity";
import TerminalDetail from "./TerminalDetail";
import Errors from "./Errors";
import CashLoad from "./CashLoad";
import BatchClose from "./BatchClose";
import TransactionHistory from "./TransactionHistory";
import AlertPlus from "./AlertPlus";

function TerminalDetailsTabs(props) {
  const [activeTab, setActiveTab] = useState(1);
  const tabs = [
      "Terminal",
      "Today's Transaction\n Last 24 Hours",
      "Trans \nHistory",
      "Banking",
      "Fees",
      "Cassette",
      "Mgmt \nActivity",
      "Alert Plus",
      "Errors",
      "Cash Load \nHistory",
      "Batch Close",
  ];

  const renderTab = () => {
    if (activeTab === 1) {
      return <TerminalDetail terminalsData={props.terminalsData} />;
    } else if (activeTab === 2) {
      return <Last24HourTrans/>;
    } else if (activeTab === 3) {
        return <TransactionHistory terminalsData={props.terminalsData} />;
    } else if (activeTab === 4) {
      return <Banking terminalsData={props.terminalsData}/>;
    } else if (activeTab === 5) {
        return <Fees terminalsData={props.terminalsData} />;
    } else if (activeTab === 6) {
        return <Cassettes terminalsData={props.terminalsData} />;
    } else if (activeTab === 7) {
        return <MgmtActivity terminalsData={props.terminalsData} />;
    }else if (activeTab === 8) {
        return <AlertPlus terminalsData={props.terminalsData}/>;
    } else if (activeTab === 9) {
        return <Errors terminalsData={props.terminalsData} />;
    } else if (activeTab === 10) {
        return <CashLoad terminalsData={props.terminalsData} />;
    } else if (activeTab === 11) {
        return <BatchClose terminalsData={props.terminalsData} />;
    }
  };
  return (
    <>
      <ul
        className="nav nav-tabs nav-tabs-custom "
        role="tablist"
        style={{ cursor: "pointer" }}
      >
        {tabs.map((tab, index) => (
          <li className="nav-item">
            <a
              className={`nav-link ${index + 1 === activeTab && "active"}`}
              data-toggle="tab"
              role="tab"
              style={{ fontSize: "10px" }}
              onClick={() => setActiveTab(index + 1)}
            >
              <span className="d-block d-sm-none">
                <i className="fas fa-address-card"></i>
              </span>
              <span
                className="d-none d-sm-block align-middle"
                style={{ whiteSpace: "pre-line" }}
              >
                {tab}
              </span>
            </a>
          </li>
        ))}
      </ul>
      <div className="tab-pane" role="tabpanel">
        {renderTab()}
      </div>
    </>
  );
}

export default TerminalDetailsTabs;
